import apiClient from '@/api/client'
import { getApiBaseUrl } from '@/api/base-url'

export interface CitySuggestion {
  id: number
  name: string
  region: string | null
  display_name: string
}

export const citiesApi = {
  async search(query: string, limit = 10): Promise<CitySuggestion[]> {
    if (query.trim().length < 2) return []

    const apiUrl = getApiBaseUrl()
    const response = await apiClient.get(`${apiUrl}/api/cities/search`, {
      params: { q: query, limit },
    })

    return response.data?.data?.cities ?? []
  },
}
